import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import img3 from '../assets/about_img.jpeg';

const AboutSection = () => {
    const { language } = useLanguage();

    return (
        <section id="about" className="py-24 bg-gray-900 overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-12">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                        className="md:w-1/2"
                    >
                        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-blue-600">
                            {language === 'en' ? 'ABOUT US' : 'À PROPOS'}
                        </h2>

                        <h3 className="text-2xl text-white font-bold mb-6 font-heading">
                            {language === 'en'
                                ? '🥊 Hassan Lafani – Champion Boxer & Coach'
                                : '🥊 Hassan Lafani – Champion de Boxe & Coach'}
                        </h3>

                        <div className="space-y-6 text-lg leading-relaxed text-gray-300">
                            <p>
                                {language === 'en'
                                    ? "I'm Hassan Lafani, a two-time Moroccan boxing champion with over 5 years of coaching experience. Certified in cardio training and kickboxing, my mission is to help you build strength, discipline, and confidence."
                                    : "Je suis Hassan Lafani, double champion du Maroc de boxe avec plus de 5 ans d'expérience en coaching. Certifié en cardio training et kickboxing, ma mission est de vous aider à développer force, discipline et confiance."}
                            </p>
                        </div>

                        <div className="mt-8">
                            <a
                                href="https://www.instagram.com/hassan_lafani?igsh=MTJsMTJjbzdjdTRodg%3D%3D&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-heading font-bold tracking-wide py-3 px-8 rounded-lg transition duration-300 shadow-lg shadow-blue-500/20 transform hover:-translate-y-1"
                            >
                                {language === 'en' ? 'BOOK NOW' : 'RÉSERVER'}
                            </a>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.8 }}
                        className="md:w-1/2 relative"
                    >
                        <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-blue-900/20 border border-gray-800">
                            <img
                                src={img3}
                                alt="Hassan Lafani Boxing Coach"
                                className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-transparent"></div>
                        </div>
                        <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-blue-600 rounded-lg z-0 opacity-20 animate-pulse"></div>
                        <div className="absolute -top-6 -left-6 w-32 h-32 bg-gray-800 rounded-lg z-0 opacity-40"></div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
